import { currencyFormatter } from '@dnhb/formatters';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'shared/hooks';
import { useLocation } from 'react-router-dom';
import analytics from 'shared/utility/analytics';
import { Collapsable, Display, DisplayLink, Heading, LabelText } from 'shared/components';
import { NAVIGATE, SYNC } from 'shared/wizard/actions';

const WizardFinal = () => {
  const dispatch = useDispatch();
  const {
    pages,
    input: {
      rent_per_month,
      applicant_dob,
      applicant_is_entrepreneur,
      applicant_has_partner,
      applicant_pension_income,
      applicant_pension_income_period,
      partner_dob,
      partner_is_entrepreneur,
      partner_pension_income,
      partner_pension_income_period,
    },
    output: {
      applicant_income,
      partner_income,
      show_applicant_pension_income,
      show_partner_pension_income,
    }
  } = useSelector(state => state)
  const location = useLocation();
  const currentPageIndex = pages.indexOf(location.state?.page);

  useEffect(() => {
    dispatch({ type: SYNC, syncing: false, recalculate: null });
    analytics.send('Bereken', 'Resultaat');
  }, []);

  return (
    <>
      <Heading>Uitgangspunten</Heading>
      <LabelText css={{ marginBottom: '24px' }}>
        Controleer hieronder je gegevens en pas ze aan als dat nodig is.
      </LabelText>
      <Collapsable title="Jouw situatie" openByDefault>
        <Display label="Huurlasten per maand" value={currencyFormatter(rent_per_month)} />
        <DisplayLink onClick={() => {
          dispatch({ type: NAVIGATE, recalculate: currentPageIndex, index: 0 });
        }}>
          Gegevens aanpassen
        </DisplayLink>
      </Collapsable>
      <Collapsable title="Jouw gegevens">
        <Display label="Geboortedatum" value={applicant_dob} />
        <Display label="Ondernemer" value={applicant_is_entrepreneur} />
        <Display label="Bruto jaarinkomen" value={currencyFormatter(applicant_income)} />
        {show_applicant_pension_income && (
          <Display
            label="Pensioen jaarinkomen"
            value={currencyFormatter(
              (applicant_pension_income_period === 'monthly' ? 12 : 1) * applicant_pension_income
            )}
          />
        )}
        <DisplayLink onClick={() => {
          dispatch({ type: NAVIGATE, recalculate: currentPageIndex, index: 1 });
        }}>
          Gegevens aanpassen
        </DisplayLink>
      </Collapsable>
      {applicant_has_partner && (
        <Collapsable title="Gegevens partner">
          <Display label="Geboortedatum" value={partner_dob} />
          <Display label="Ondernemer" value={partner_is_entrepreneur} />
          <Display label="Bruto jaarinkomen" value={currencyFormatter(partner_income)} />
          {show_partner_pension_income && (
            <Display
              label="Pensioen jaarinkomen"
              value={currencyFormatter((partner_pension_income_period === 'monthly' ? 12 : 1) * partner_pension_income)}
            />
          )}
          <DisplayLink onClick={() => {
            dispatch({ type: NAVIGATE, recalculate: currentPageIndex, index: 2 });
          }}>
            Gegevens aanpassen
          </DisplayLink>
        </Collapsable>
      )}
    </>
  );
};

export default WizardFinal;
